import { getUserVar, setUserVar, USER_VARIABLE } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { SsrQuery } from '@nx-frontend/shared/types';

interface SetIsDashboardFirstVisitParams {
  query: SsrQuery | { [key: string]: string | undefined } | undefined;
  user: { id: number; registerDate: number } | null;
}

/**
 * Set userVars isDashboardFirstVisit = false when user visits dashboard for the first time
 *
 * @Note: at first isDashboardFirstVisit used for redirect user to dashboard if he didn't visit it yet. Then is start used for marketing
 * to detect user who visited dashboard for the first time after trial activation
 * @param params
 */
export const setIsDashboardFirstVisit = async (params: SetIsDashboardFirstVisitParams): Promise<void> => {
  const { user, query } = params;
  const hasQueryParams =
    query?.show_trial_popup || query?.trial_activated || query?.from === 'wizard' || query?.from_call_popup;
  let isFirstVisit = (user?.registerDate || 0) >= 1708955085;
  if (!hasQueryParams) {
    try {
      const { value } = await getUserVar({
        host: generalEnv.userServiceUrl,
        userId: user?.id,
        key: USER_VARIABLE.IS_DASHBOARD_FIRST_VISIT,
      });
      isFirstVisit = value as boolean;
    } catch (err) {
      // ignore
    }
  }
  if (isFirstVisit && !query?.show_trial_popup) {
    await setUserVar({
      host: generalEnv.userServiceUrl,
      userId: user?.id,
      key: USER_VARIABLE.IS_DASHBOARD_FIRST_VISIT,
      value: false,
    });
  }
};
